
import {Container,Nav,Navbar,Offcanvas, Image } from 'react-bootstrap';
import './Style/NavStyle.css'
function NavComp(){
    const expand = "md";

    
    return(
        <Navbar key={expand} expand={expand} className="mb-3 customNav"
        >
        <Container fluid >
          <Navbar.Brand href="#"><Image fluid src='./imgs/logos.png' style={{maxWidth:"70px"}}/></Navbar.Brand>
          <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-${expand}`}/>
          <Navbar.Offcanvas
            id={`offcanvasNavbar-expand-${expand}`}
            aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
            placement="end"
          >
            <Offcanvas.Header closeButton style={{backgroundColor:"#0f70b7"}}>
            </Offcanvas.Header>
            <Offcanvas.Body style={{backgroundColor:"#0f70b7"}}>
              <Nav className="justify-content-center flex-grow-1 pe-3">
                <Nav.Link href="#action1" className=''>الاحصائيات</Nav.Link>
                <Nav.Link href="#action2" className=''>الخدمات</Nav.Link>
                <Nav.Link href="#action1" className=''>تواصل معنا</Nav.Link>
              </Nav>
            </Offcanvas.Body>
          </Navbar.Offcanvas>
        </Container>
      </Navbar>
    )
}

export default NavComp;